import {useState} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";


export default function CustomerUsersFilterRoles(props) {
    //console.debug("RTS Break CustomerUsersFilterRoles");

    const [role, setRole] = useState(props.role==null?-1:props.role);
    const [repoValues] = useState([{value:-1, label:"All"}
                                    ,{value:1, label:"Crew Member"}
                                    ,{value:25, label:"Associate"}
                                    ,{value:50, label:"Manager"}
                                    ,{value:75, label:"Administrator"}
                                ]);


    function valChange(e, val){
        setRole(val.value);
        props.setRoleFx(val.value);
        props.setFormDirtyFx(1);
    }

 
    return(
        <>
            <Autocomplete
                options={repoValues}
                renderInput={(params) => <TextField {...params} label="Role"  size="small" />}
                value={repoValues.find(v => v.value===role)}
                onChange={valChange}
                getOptionLabel={(repoValues) => repoValues.label}
                disableClearable={true}
                renderOption={(props, repoValues) => (
                    <Box component="li" {...props} key={repoValues.value}>
                        {repoValues.label}
                    </Box>
                )}
            />
        </>
    );
}
